



















import Vue from 'vue';
import { PaymentMethod, Card } from '../types';

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export default Vue.extend({
  name: 'payment-method-item',
  props: {
    paymentMethod: {
      type: Object as () => PaymentMethod,
      required: true,
    },
  },
  computed: {
    card(): Card {
      return this.paymentMethod.card;
    },
    expires(): string {
      return `${months[this.card.expMonth - 1]}/${this.card.expYear}`;
    },
    isPrimary(): boolean {
      return this.paymentMethod.isPrimary;
    },
  },
});
